import { render } from "./ParadigmInspection.vue?vue&type=template&id=4929db98&ts=true"
import script from "./ParadigmInspection.vue?vue&type=script&lang=ts"
export * from "./ParadigmInspection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__